// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popover_popover__rvesj","item":"Popover_item__s8FXW","active":"Popover_active__1Cmnl"};